import { useQuery } from '@apollo/client';
import axios from 'axios';
import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';
import { useAsync } from 'react-use';

import { keysToCamel } from '@utils/butter';
import { ApiEndpoints } from '@utils/endpoints';

import { useAuth } from '@providers/AuthProvider';

import { IPageProps } from '@folx-types/flow-steps';
import { IAccountInfoQueryData } from '@folx-types/member';

import ACCOUNT_INFO_QUERY from '@graphql/queries/AccountInfo.query.gql';

import LegalInfoEditStep, { ILegalInfoEditStepPageContent } from './LegalInfoEditStep.component';

interface ILegalInfoEditStepPageProps extends IPageProps {}

const LegalInfoEditStepPage: FC<ILegalInfoEditStepPageProps> = ({ path }) => {
	const { getAuthToken } = useAuth();

	const { data: accountData } = useQuery<IAccountInfoQueryData>(ACCOUNT_INFO_QUERY, {
		fetchPolicy: 'cache-and-network',
	});

	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "legal-info-edit-step" }) {
				page_header
				id_label
				ssn_label
				ssn_disclaimer
				legal_name_label
				legal_name_disclaimer
			}
		}
	`);

	const member = accountData?.currentMember;

	const { value: idImage } = useAsync(async () => {
		const authorizationToken = await getAuthToken();
		const idImageData = await axios.get(`${ApiEndpoints.memberPortal}/image/idImage`, {
			headers: {
				Accept: 'image/png, image/jpeg, image/gif, application/pdf',
				authorizationToken,
			},
			responseType: 'blob',
		});

		if (!idImageData) return;
		return URL.createObjectURL(idImageData.data);
	}, []);

	const refinedContent = keysToCamel(pageContent) as ILegalInfoEditStepPageContent;

	return (
		<LegalInfoEditStep pageContent={refinedContent} path={path} member={member} idImage={idImage} />
	);
};

export default LegalInfoEditStepPage;
